import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import moment from 'moment';

const timer_borser = moment('06:30:00', 'HH:mm:ss');

interface ShiftVDPFactState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftVDPFactState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const GET_SHIFT_FACT_VDP = 'GET_SHIFT_FACT_VDP';


export const actions: ActionTree<ShiftVDPFactState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          vm.$db([
            vm.$q(GET_SHIFT_FACT_VDP)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sw.id',
                  employee_name: 'e.name',
                  role_name: 'role.name',
                  is_manager: 'role.is_manager',
                  is_combined: 'sw.is_combined',
                  combine_time: 'sw.combine_time',
                  is_timer_start: 'sw.is_timer_start',
                  timer_value: 'sw.timer_value',
                  started_at: {
                    $min: 'swt.started_at'
                  },
                  ended_at: {
                    $max: 'swt.ended_at'
                  },
                },
                from: 's:shift_workers',
                from_as: 'sw',
                joins: [
                  {
                    join: 's:employees',
                    type: 'left',
                    as:   'e',
                    on: {
                      $eq: ['e.id', 'sw.employee_id']
                    }
                  },
                  {
                    join: 's:voc_roles',
                    type: 'left',
                    as:   'role',
                    on: {
                      $eq: ['sw.role_id', 'role.id']
                    }
                  },
                  {
                    join: 's:shift_workers_timers',
                    type: 'left',
                    as:   'swt',
                    on: {
                      $eq: ['swt.shift_worker_id', 'sw.id']
                    }
                  },
                ],
                order: [
                  {$asc: ['sw.id']}
                ],
                where: {
                  $eq: [`sw.shift_id`, {$: documentId}]
                },
                groups: [
                  'sw.id',
                  'e.name',
                  'role.name',
                  'role.is_manager',
                  'sw.is_combined',
                  'sw.combine_time',
                  'sw.is_timer_start',
                  'sw.timer_value',
                ]
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_SHIFT_FACT_VDP);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {

                if (item.timer_value != '00:00:00.000000') {
                  const timer = moment(item.timer_value, 'HH:mm:ss.SSSSSS');
                  item.timer_value = timer.subtract( (timer.diff(timer_borser) < 0) ? 30 : 60, 'minutes').format('HH:mm:ss.SSSSSS')
                }
                return item
              })
            }

            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>ФИО</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Менеджер</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Совмещение</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Роль</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время совмещения</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Рабоче время</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Начало работы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Конец работы</td>
</tr>
{{#workers.documents}}
  <tr height="auto">
    <td wrap border base>{{employee_name}}</td>
    <td wrap border base type=boolean align=center>{{is_manager}}</td>
    <td wrap border base type=boolean align=center>{{is_combined}}</td>
    <td wrap border base>{{role_name}}</td>
    {{#is_combined}}
    <td wrap border base type=time align=center>{{combine_time}}</td>
    {{/is_combined}}
    {{^is_combined}}
    <td wrap border base align=center>-</td>
    {{/is_combined}}
    <td wrap border base type=time align=center>{{timer_value}}</td>
    <td wrap border type=date date-format="DD.MM.YYYY HH:mm" align=center>{{started_at}}</td>
    <td wrap border type=date date-format="DD.MM.YYYY HH:mm" align=center>{{ended_at}}</td>
  </tr>
{{/workers.documents}}
</table>
                `,
                queries: {
                  workers: {
                    columns: {
                      id: 'sw.id',
                      employee_name: 'e.name',
                      role_name: 'role.name',
                      is_manager: 'role.is_manager',
                      is_combined: 'sw.is_combined',
                      combine_time: 'sw.combine_time',
                      is_timer_start: 'sw.is_timer_start',
                      timer_value: 'sw.timer_value',
                      started_at: {
                        $min: 'swt.started_at'
                      },
                      ended_at: {
                        $max: 'swt.ended_at'
                      },
                    },
                    from: 's:shift_workers',
                    from_as: 'sw',
                    joins: [
                      {
                        join: 's:employees',
                        type: 'left',
                        as:   'e',
                        on: {
                          $eq: ['e.id', 'sw.employee_id']
                        }
                      },
                      {
                        join: 's:voc_roles',
                        type: 'left',
                        as:   'role',
                        on: {
                          $eq: ['sw.role_id', 'role.id']
                        }
                      },
                      {
                        join: 's:shift_workers_timers',
                        type: 'left',
                        as:   'swt',
                        on: {
                          $eq: ['swt.shift_worker_id', 'sw.id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['sw.id']}
                    ],
                    where: {
                      $eq: [`sw.shift_id`, {$: documentId}]
                    },
                    groups: [
                      'sw.id',
                      'e.name',
                      'role.name',
                      'role.is_manager',
                      'sw.is_combined',
                      'sw.combine_time',
                      'sw.is_timer_start',
                      'sw.timer_value',
                    ]
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
      })
    }
};

export const mutations: MutationTree<ShiftVDPFactState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftVDPFactState, RootState> = {
  totals : (state: ShiftVDPFactState) => {
    return {
      sum: state.relatedFactsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
};

export const STORE_KEY = '$_shift_worker_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
